'use client';

import { ReactNode } from 'react';
import { MARKETING_TOKENS as T } from './marketingTokens';

/**
 * The little icon + label pill that sits above every marketing hero headline.
 * Rendered as a plain span (not a MUI Chip) so the icon is ordinary children —
 * which also sidesteps the old RSC→client `cloneElement` icon-vanish bug the
 * MUI version worked around. The `[&>svg]` rule sizes whatever icon is passed
 * (MUI or lucide) to 14px, so callers don't size it themselves.
 */
export default function MarketingPill({
  icon,
  label,
  /** Pills on a primary-coloured surface (e.g. the highlighted pricing card). */
  onPrimary = false,
}: {
  icon: ReactNode;
  label: string;
  onPrimary?: boolean;
}) {
  return (
    <span
      className="inline-flex h-[30px] items-center gap-1.5 rounded-full px-3 text-[12px] font-semibold"
      style={{
        backgroundColor: onPrimary ? 'rgba(255,255,255,0.16)' : T.SURFACE,
        color: onPrimary ? T.ON_PRIMARY : T.TEXT,
        border: `1px solid ${onPrimary ? 'rgba(255,255,255,0.28)' : T.BORDER}`,
      }}
    >
      <span aria-hidden className="inline-flex items-center [&>svg]:h-3.5 [&>svg]:w-3.5" style={{ color: onPrimary ? T.ON_PRIMARY : T.PRIMARY }}>
        {icon}
      </span>
      {label}
    </span>
  );
}
